import React from 'react';

const EXTERNAL_LINK_CLASS = 'text-blue-600 underline hover:text-blue-800';

export default function CondicionesGeneralesMexico({
  emailContacto,
  company,
  razonSocial,
}) {
  return (
    <div className='space-y-4'>
      {/* Introducción - va primero según el documento */}
      <p>Estimado pasajero:</p>
      <p>
        Atendiendo su solicitud de intermediación en la contratación de servicios turísticos, esta
        Agencia cumple con informarle las condiciones generales de contratación, conforme a lo
        establecido por la Ley Federal de Protección al Consumidor, la Norma Oficial Mexicana
        NOM-010-TUR-2001, y demás disposiciones legales aplicables en los Estados Unidos
        Mexicanos.
      </p>
      {emailContacto ? (
        <p>
          Es de vital importancia para su viaje que usted lea cuidadosamente las presentes
          condiciones. Si está de acuerdo, le solicitamos que nos envíe su aceptación al siguiente
          correo electrónico: {emailContacto}
        </p>
      ) : (
        <p>
          Es de vital importancia para su viaje que usted lea cuidadosamente las presentes
          condiciones.
        </p>
      )}
      <p>
        Esta Agencia solo procederá con la gestión de su reserva previa lectura y aceptación
        expresa de las presentes condiciones.
      </p>
      {(razonSocial || company) && (
        <p>
          Atentamente: {razonSocial || company}.
        </p>
      )}

      <h4 className='text-lg text-black font-bold mt-6'>SOLICITUDES Y PAGOS:</h4>

      <p>
        <strong>1. Modificaciones de precio y servicios:</strong> Los precios y/o reservaciones de
        los servicios turísticos ofertados están sujetos a modificación sin previo aviso cuando
        ocurran alteraciones en los servicios contratados, cambios en costos, tarifas, impuestos
        o tipos de cambio, por causas ajenas a esta Agencia y al consumidor. Esto conforme a lo
        dispuesto por el Artículo 56 de la Ley Federal de Protección al Consumidor (LFPC).
      </p>

      <p>
        <strong>2. Pagos anticipados y confirmación de servicios:</strong> Todos los importes
        pagados con anterioridad a la confirmación definitiva de los servicios serán considerados
        como anticipos o reservas en trámite. La confirmación definitiva se entenderá realizada
        con la emisión de boletos, vouchers (órdenes de servicio) y/o facturación
        correspondiente, de acuerdo con el itinerario y condiciones previamente informadas.
      </p>

      <p>
        <strong>3. Pagos a crédito y condiciones de financiamiento:</strong> En caso de operaciones
        a crédito o financiamiento, el pasajero deberá cumplir con los requisitos y condiciones
        establecidos por las entidades financieras correspondientes (bancos, plataformas de pago,
        billeteras virtuales, etc.). El incumplimiento de los pagos en los plazos y formas
        acordados podrá derivar en la cancelación de la reserva confirmada, así como en la
        pérdida total del anticipo entregado, sin derecho a reembolso o compensación alguna,
        conforme a lo acordado contractualmente. En el caso de servicios aéreos, las condiciones
        de la tarifa, clase, penalizaciones por cambios o cancelaciones y otras restricciones, se
        regirán por las políticas propias de cada compañía aérea, conforme a la Ley de Aviación
        Civil y a las disposiciones de la Asociación Internacional de Transporte Aéreo (IATA).
      </p>

      <p>
        <strong>4. Tarifas y condiciones especiales:</strong> Al momento de la cotización, ya sea a
        través del sitio web de la Agencia o por medio de un asesor de ventas, se mostrará la
        tarifa más económica disponible registrada en los sistemas globales de reservaciones
        (GDS) para transporte aéreo y/o servicios turísticos terrestres. Estas tarifas suelen
        estar sujetas a restricciones específicas, tales como la no posibilidad de cambios ni
        reembolsos, o bien permitirlos solo con penalidades o diferencias tarifarias impuestas
        por el proveedor. El pasajero acepta que al adquirir tarifas promocionales (como
        &quot;superflex&quot; u otras de bajo costo), estará sujeto a las condiciones específicas que
        determine el proveedor del servicio, sin responsabilidad para esta Agencia en cuanto a
        cambios, cancelaciones, reembolsos o penalizaciones impuestas por dicho proveedor.
      </p>

      <p>
        <strong>5. Cotizaciones en moneda extranjera:</strong> Cuando los servicios se presten
        fuera del territorio nacional, o se trate de vuelos con tarifas de grupo, bloqueos o
        charters, los precios serán cotizados en moneda extranjera. Los pagos se realizarán en
        pesos mexicanos, al tipo de cambio vigente en la fecha y hora del pago, conforme al valor
        publicado por el Banco de México. El saldo restante se cubrirá en pesos mexicanos, al
        tipo de cambio vigente al momento en que se acredite el pago en las cuentas informadas
        por esta Agencia. En caso de cancelación de servicios originalmente pagados en moneda
        extranjera, los reembolsos se efectuarán en pesos mexicanos, al tipo de cambio vigente
        al momento del reembolso, en cumplimiento de la Ley Monetaria de los Estados Unidos
        Mexicanos y el Artículo 8 de la LFPC.
      </p>

      <p>
        <strong>6. Pagos en efectivo y disposiciones fiscales:</strong> Los pasajeros que realicen
        pagos en efectivo deberán atender las disposiciones establecidas en la Ley Federal para
        la Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita,
        incluyendo los límites permitidos para transacciones en efectivo. Aquellos que contraten
        servicios a prestarse en el extranjero reconocen que existen restricciones cambiarias y
        fiscales derivadas de disposiciones gubernamentales ajenas a esta Agencia. Asimismo, el
        pasajero se obliga a cumplir con las disposiciones fiscales aplicables en México,
        incluyendo aquellas relacionadas con percepciones, retenciones o comprobantes fiscales
        digitales (CFDI), conforme a la normatividad del Servicio de Administración Tributaria
        (SAT).
      </p>

      <h4 className='text-lg text-black font-bold mt-6'>DATOS PERSONALES:</h4>
      <p>
        El pasajero deberá informar sus datos personales en forma veraz, exacta y vigente. Siendo
        responsable el pasajero de la veracidad y autenticidad de los mismos. Es responsabilidad
        del pasajero informar debida y correctamente a la Agencia de viajes la totalidad de sus
        datos personales y de las personas que viajen con él, tanto en cuanto a nombres completos
        y correctos, nacionalidad, fecha de nacimiento, números y tipo de documento requeridos,
        domicilio y demás datos que se le soliciten de acuerdo al destino; deberá informar si los
        pasaportes y/u otra documentación exigida para viajar están debidamente actualizados y
        encontrarse en condiciones adecuadas, legibles y en buen estado, además de los datos de
        contacto necesarios y solicitados por las aerolíneas y/o transportadores y/u operadores,
        por cuestiones de seguridad y conforme las normas internacionales vigentes.
      </p>

      <h4 className='text-lg text-black font-bold mt-6'>LOS PRECIOS INCLUYEN:</h4>
      <p>
        <strong>1. Servicios especificados en el itinerario:</strong> Los precios incluyen
        exclusivamente los servicios detallados en el itinerario provisto por el prestador de
        servicios turísticos, de conformidad con la información proporcionada previamente al
        pasajero y conforme a lo señalado en el voucher de servicios y demás documentación
        oficial de viaje.
      </p>
      <p>
        <strong>2. Transporte (cuando esté incluido):</strong> Cuando el transporte esté
        expresamente indicado como parte del servicio, éste será proporcionado conforme al medio,
        itinerario, condiciones y modalidad señalados (servicio regular, chárter o por sistema de
        bloque de espacios —block off—), incluyendo los trayectos de ida y vuelta. La clase,
        características y categoría del transporte se determinarán según el proveedor contratado
        y el destino final, pudiendo incluir vuelos directos o con escalas y/o conexiones, de
        acuerdo con las condiciones del paquete turístico.
      </p>
      <p>
        <strong>3. Asistencia al viajero (si aplica):</strong> Se incluye asistencia al viajero,
        únicamente en los casos en que se indique de forma expresa en la documentación del viaje
        (voucher o itinerario), conforme a las condiciones y cobertura establecidas por la
        aseguradora o proveedor del servicio de asistencia. La Agencia no será responsable por
        exclusiones, condiciones o limitaciones establecidas por el proveedor del servicio de
        asistencia.
      </p>
      <p>
        <strong>4. Alojamiento:</strong> El hospedaje será proporcionado en los hoteles indicados en
        el itinerario, o en su caso, en hoteles de categoría igual o superior (en caso de
        sustitución), en habitaciones sencillas, dobles o triples, según el número de pasajeros,
        con baño privado e impuestos incluidos, salvo que se indique lo contrario. En algunos
        destinos, ciertos impuestos o tasas locales (como tarifa de hospedaje, resort fee o
        impuesto por pernocta) podrán cobrarse directamente al pasajero en destino, conforme a
        las leyes locales, sin que la Agencia tenga injerencia sobre ello. El régimen de comidas
        (desayuno, media pensión, pensión completa, etc.) será el que se especifique en cada
        caso. Las visitas guiadas o excursiones también se incluyen únicamente si están
        expresamente mencionadas en la documentación del viaje.
      </p>
      <p>
        <strong>5. Traslados (si aplica):</strong> Se incluyen los traslados desde y hacia
        aeropuertos, terminales u hoteles, únicamente si así se establece en el itinerario o
        voucher correspondiente. El número de noches de hospedaje estará indicado en el voucher
        de servicios. De acuerdo con los usos internacionales y normativas hoteleras locales, el
        horario estándar de check-in inicia a partir de las 15:00 horas, y el check-out debe
        realizarse antes de las 12:00 horas del día siguiente, independientemente del horario
        real de llegada o salida del pasajero. Si el hotel fija un horario de salida distinto por
        reglamentación interna, el pasajero deberá respetar dichas condiciones. En caso de
        exceder dicho horario, cualquier cargo adicional será responsabilidad directa del
        pasajero, conforme a la tarifa vigente en el establecimiento (tarifa rack o tarifa de
        mostrador), sin responsabilidad para la Agencia.
      </p>
      <p>
        <strong>6. Duración del tour:</strong> La duración del tour será la establecida en el
        itinerario, considerando como primer día el indicado en la documentación de viaje y como
        último día el correspondiente a la salida del destino final, independientemente de los
        horarios de vuelos o traslados.
      </p>
      <p>
        <strong>7. Habitaciones triples (si aplica):</strong> En general, los hoteles disponen de un
        número limitado de habitaciones triples. Es frecuente que estas consistan en una
        habitación doble con cama adicional (plegable o desarmable), lo cual puede afectar la
        comodidad. Esta situación es conocida y aceptada por el pasajero al contratar el
        servicio, liberando de toda responsabilidad al hotel, a la Agencia y al operador
        mayorista.
      </p>
      <p>
        <strong>- Ejemplo (aplicable a México y EE. UU.)</strong> Las habitaciones en dichos
        destinos suelen tener dos camas matrimoniales tipo Queen, con capacidad de hasta cuatro
        personas (2 adultos y 2 menores de hasta 12 años) en una misma habitación. Cuando se
        indique DBLFP, se entenderá que incluye una habitación doble familiar con dos camas
        Queen, para los ocupantes indicados, sujeto a disponibilidad y a lo permitido por las
        autoridades sanitarias vigentes.
      </p>
      <p>
        <strong>8. Baño privado o compartido, comidas y excursiones:</strong> Según la tarifa
        contratada, el alojamiento podrá ser con baño privado o compartido, de acuerdo con lo
        indicado en el itinerario. El régimen alimenticio y la inclusión de visitas y excursiones
        se regirán por lo especificado expresamente en cada caso.
      </p>
      <p className='border border-gray-300 rounded-lg bg-gray-100 p-4'>
        <strong>NOTAS:</strong> 1) La categoría de los hoteles que se incluyan en los itinerarios
        son otorgadas por las autoridades turísticas del sitio geográfico en el que se encuentran
        y su otorgamiento y control es administrativo. La Agencia no asume responsabilidad alguna
        sobre los criterios que rijan ese control y otorgamiento. 2) Las tarifas turísticas que
        imponen los prestadores dependen de variables como promociones estacionales, anticipación
        de compra, y en caso de las aéreas de restricciones. En consecuencia, pueden variar su
        costo rápidamente siendo la Agencia totalmente ajena a dicha modificación.
      </p>

      <h4 className='text-lg text-black font-bold mt-6'>SERVICIOS Y RUBROS NO INCLUIDOS:</h4>
      <p>
        Los precios publicados, cotizados o contratados no incluyen, salvo que expresamente se
        indique lo contrario en el voucher de servicios, orden de servicio, itinerario confirmado
        o documentación oficial, los siguientes conceptos:
      </p>
      <p>
        <strong>1. Gastos personales y extras no especificados:</strong> Gastos de carácter
        personal tales como: bebidas, lavandería, planchado, propinas, llamadas telefónicas, uso
        de servicios especiales del hotel, servicio a la habitación, acceso a instalaciones con
        costo adicional, entre otros. Gastos derivados de exceso de equipaje, penalidades por no
        realizar el check-in en línea, peajes, tasas de embarque, tarifas portuarias o
        aeroportuarias no incluidas en el boleto, y cualquier otro cargo adicional no contemplado
        expresamente en el servicio contratado. Impuestos adicionales como IVA, retenciones fiscales, percepciones,
        tasas migratorias o aranceles aduaneros, actuales o futuros, así como cualquier costo
        relacionado con trámites sanitarios, vacunación, pruebas médicas o bioquímicas (ej.
        COVID-19, fiebre amarilla u otros requerimientos de entrada al país de destino o de
        regreso a México). Gastos derivados de la obtención urgente o express de pasaportes,
        visados, autorizaciones migratorias u otra documentación requerida para el viaje, salvo
        que se indique expresamente su inclusión.
      </p>
      <p>
        <strong>2. Entradas y accesos no especificados:</strong> Entradas a museos, zonas
        arqueológicas, atracciones turísticas, parques nacionales, actividades recreativas u
        opcionales, ni impuestos o tasas locales exigidas por gobiernos estatales, municipales o
        extranjeros. Cualquier excursión opcional o actividad no señalada como &quot;incluida&quot; corre
        por cuenta del pasajero.
      </p>
      <p>
        <strong>3. Alimentos en ruta:</strong> No se incluye alimentación durante los trayectos
        terrestres, aéreos o marítimos, salvo que se indique expresamente en el itinerario o
        documentación entregada.
      </p>
      <p>
        <strong>4. Gastos financieros:</strong> No se incluyen intereses, comisiones o gastos por
        financiamiento a crédito. Estos estarán sujetos a los términos y condiciones establecidos
        por la entidad financiera correspondiente y deberán ser cubiertos directamente por el
        pasajero.
      </p>
      <p>
        <strong>5. Trámites migratorios (visas, permisos):</strong> Los costos por visados,
        autorizaciones electrónicas o permisos migratorios (por ejemplo, ESTA para EE.UU. o eTA
        para Canadá), cuando se requieran, no están incluidos y son responsabilidad exclusiva del
        pasajero, salvo que se indique lo contrario de forma explícita.
      </p>
      <p>
        <strong>6. Prolongación de estancia o servicios no previstos:</strong> No se incluyen gastos
        derivados de la extensión voluntaria de servicios o estadías, ni los generados por caso
        fortuito, fuerza mayor o situaciones fuera del control razonable del organizador (como
        desastres naturales, pandemias, disturbios, cierres de fronteras o cancelaciones
        impuestas por las autoridades gubernamentales). Tampoco se cubren los costos derivados de
        estar varado por razones sanitarias dispuestas por alguna autoridad (aislamiento
        obligatorio, cuarentenas, etc.).
      </p>
      <p>
        <strong>7. Alquiler de vehículos:</strong> En caso de contratarse servicios de renta de
        autos u otros vehículos, no están incluidos: combustible, peajes, GPS, seguros
        (optativos u obligatorios), ni impuestos adicionales, salvo que se especifique
        expresamente lo contrario en el contrato o voucher.
      </p>
      <p>
        <strong>8. Asignación de asientos en vuelos:</strong> Los cargos por elección anticipada de
        asientos en vuelos comerciales no están incluidos. Esta Agencia podrá, a solicitud del
        pasajero, gestionar la solicitud de un asiento específico ante la aerolínea, pero no
        garantiza su disponibilidad ni gratuidad, ya que está sujeta a políticas de cada
        aerolínea.
      </p>
      <p>
        <strong>9. Asistencia al viajero:</strong> El servicio de asistencia al viajero no está
        incluido, salvo que se indique expresamente. Es responsabilidad del pasajero contratar
        una póliza de asistencia adecuada al destino, duración y condiciones del viaje, incluyendo
        cobertura para eventos sanitarios, hospitalización, cancelaciones por cierre de fronteras,
        o repatriación médica. En el caso de viajes a países con requisitos sanitarios o
        migratorios específicos (como el Tratado Schengen para Europa), el pasajero deberá
        verificar y contratar el seguro con las coberturas exigidas. La Agencia no será
        responsable por situaciones o gastos derivados de incidentes cubiertos por pólizas de
        asistencia que el pasajero no haya contratado o que resulten insuficientes para sus
        necesidades personales (edad, condiciones de salud, etc.).
      </p>
      <p className='border border-amber-200 rounded bg-amber-50 p-3'>
        <strong>NOTA:</strong> PRESTE ATENCION A QUE LA TARIFA AEREA ELEGIDA CONTENGA AL MENOS 1
        PIEZA DE EQUIPAJE SI UD. LO DESEA.
      </p>

      <h4 className='text-lg text-black font-bold mt-6'>CANCELACIONES, REEMBOLSOS Y PLAZOS:</h4>
      <p>
        En caso de que el pasajero decida cancelar o desistirse del viaje contratado, deberá
        notificar a la Agencia por escrito de forma clara e inequívoca, a través del medio de
        comunicación registrado al momento de la contratación (correo electrónico o carta
        firmada). La fecha de recepción por parte de la Agencia será considerada como la fecha
        oficial de cancelación.
      </p>
      <p>
        <strong>1. Cancelación antes del viaje:</strong> Cuando se trate de desistimientos que
        involucren servicios ya confirmados por la Agencia con terceros (líneas aéreas, hoteles,
        operadores, navieras, etc.), el reembolso estará sujeto a las condiciones contractuales
        específicas de cada proveedor.
      </p>
      <p>La Agencia podrá retener:</p>
      <ul className='list-disc pl-6 space-y-1'>
        <li>Gastos administrativos y de gestión.</li>
        <li>Penalidades impuestas por los prestadores de servicios.</li>
        <li>Una comisión equivalente al 10% del valor de los servicios contratados con terceros.</li>
        <li>Las cantidades entregadas en concepto de reserva o anticipo no serán reembolsables ni aplicables a futuras contrataciones, salvo que la Agencia indique lo contrario por escrito.</li>
      </ul>
      <p>
        En la compra de
        boletos de avión, se estará a lo dispuesto en la base tarifaria contratada por el
        pasajero y a las condiciones generales del Contrato de Transporte Aéreo. En la mayoría de
        los casos, se cotiza con base en tarifas promocionales que no permiten cambios ni
        reembolsos. *El inicio del cómputo de penalidades se contará a partir de la recepción
        formal de la solicitud de cancelación.
      </p>
      <p>
        <strong>2. Cancelación en operaciones a crédito:</strong> En operaciones financiadas o
        contratadas a crédito, no se reembolsarán los importes correspondientes a:
      </p>
      <ul className='list-disc pl-6 space-y-1'>
        <li>Gastos administrativos</li>
        <li>Honorarios por tramitación de crédito</li>
        <li>Sellos fiscales o notariales</li>
        <li>Intereses generados, en caso de haberlos</li>
      </ul>
      <p>
        <strong>3. Condiciones especiales por tipo de servicio:</strong> Existen condiciones
        específicas de cancelación y penalidades cuando se contratan servicios como:
      </p>
      <ul className='list-disc pl-6 space-y-1'>
        <li>Hoteles, cruceros, centros de esquí, vuelos chárter, seguros de viaje</li>
        <li>Eventos especiales: Carnaval, Año Nuevo (Reveillón), ferias, congresos, festivales y otros de alta demanda</li>
      </ul>
      <p>
        En estos casos, las condiciones de cancelación y reembolso estarán sujetas a las políticas
        particulares del proveedor, las cuales prevalecerán sobre las generales y serán informadas
        al momento de la contratación. En temporadas de eventos especiales, es común que los
        servicios sean no reembolsables.
      </p>
      <p>
        <strong>4. Vuelos chárter o con espacio bloqueado (Block Off):</strong> En caso de viajes
        contratados mediante vuelos chárter o bloqueos de espacio con aerolíneas, aplicarán las
        condiciones establecidas por el transportista aéreo, conforme a lo dispuesto en la Ley de
        Aviación Civil mexicana y en su caso, la Convención de Montreal. En viajes grupales, las
        condiciones (fechas límite de pago, penalidades, y condiciones específicas) serán
        informadas previamente al pasajero.
      </p>
      <p>
        <strong>5. No presentación (No Show):</strong> Si el pasajero no se presenta en la fecha,
        hora y lugar indicados para la salida del viaje, sin causa justificada o sin notificación
        previa, será considerado como &quot;No Show&quot;. Esto implica:
      </p>
      <ul className='list-disc pl-6 space-y-1'>
        <li>Pérdida total del valor del boleto aéreo, conforme a las políticas de la aerolínea</li>
        <li>Pérdida de los servicios terrestres o de hotelería contratados, sin derecho a reembolso</li>
      </ul>
      <p>
        En caso de cancelación por parte de la Agencia debido a la no conformación del grupo mínimo
        requerido para realizar una excursión o viaje, el pasajero tendrá derecho únicamente al
        reembolso de las cantidades pagadas, sin actualización ni intereses. Si durante el viaje el
        pasajero decide voluntariamente no hacer uso de uno o varios servicios contratados, no
        tendrá derecho a reembolso ni compensación alguna.
      </p>
      <p>
        <strong>6. Política general de reembolsos por cancelación anticipada:</strong> En cancelación
        anticipada por motivos inherentes al pasajero regirán las siguientes penalidades, salvo
        que el proveedor indique otras condiciones:
      </p>
      <table className='min-w-full border border-gray-300 my-4'>
        <thead>
          <tr className='bg-gray-100'>
            <th className='border border-gray-300 px-3 py-2 text-left'>Tiempo de anticipación (antes del inicio del servicio)</th>
            <th className='border border-gray-300 px-3 py-2 text-left'>Penalidad aplicable</th>
          </tr>
        </thead>
        <tbody>
          <tr><td className='border border-gray-300 px-3 py-2'>Más de 30 días naturales</td><td className='border border-gray-300 px-3 py-2'>40% del total pagado</td></tr>
          <tr><td className='border border-gray-300 px-3 py-2'>Entre 29 y 15 días naturales</td><td className='border border-gray-300 px-3 py-2'>50% del total pagado</td></tr>
          <tr><td className='border border-gray-300 px-3 py-2'>Entre 14 y 5 días naturales</td><td className='border border-gray-300 px-3 py-2'>70% del total pagado</td></tr>
          <tr><td className='border border-gray-300 px-3 py-2'>Menos de 5 días o no presentación</td><td className='border border-gray-300 px-3 py-2'>100% del total pagado</td></tr>
        </tbody>
      </table>
      <p>
        Estas penalidades son independientes de las aplicables por prestadores particulares y no
        excluyen otras condiciones adicionales de cancelación informadas previamente. Las
        cantidades pagadas como anticipo o apartado no son reembolsables ni compensables. Para
        boletos de avión, regirán las condiciones específicas de la tarifa adquirida. Para
        servicios marítimos (cruceros), se aplicarán las condiciones establecidas por la naviera
        o armador del buque.
      </p>
      <p>
        <strong>7. Plazo para solicitar reembolsos:</strong> Todas las solicitudes de devoluciones o
        reembolsos deberán ser presentadas por el pasajero ante la Agencia dentro de los 30
        (treinta) días naturales siguientes a la fecha de finalización del viaje. Fuera de ese
        plazo, no se aceptarán reclamaciones, salvo causas justificadas conforme a la ley.
      </p>
      <p className='border border-gray-300 rounded bg-gray-100 p-3'>
        <strong>NOTA:</strong> ATENTO EL CARÁCTER DE INTERMEDIARIO DE LA AGENCIA, EL PASAJERO DEBE
        SABER QUE TODO CAMBIO Y/O CANCELACIÓN SE REGIRÁN POR LAS DETERMINACIONES DEL PROVEEDOR
        TURÍSTICO. SIN PERJUICIO DE ELLO LA AGENCIA ASUME EL COMPROMISO DE REALIZAR LAS
        GESTIONES NECESARIAS DE PRESENTACIÓN Y SEGUIMIENTO, PERO LA DECISIÓN FINAL PROVIENE
        SIEMPRE DEL PROVEEDOR. RECUERDE QUE CADA PROVEEDOR O PRESTADOR DEFINE LAS PENALIDADES SIN
        INTERVENCIÓN DE LA AGENCIA.
      </p>

      <h4 className='text-lg text-black font-bold mt-6'>TRANSPORTE NO REGULAR - CHARTER:</h4>
      <p>
        El pasajero declara que fue debidamente informado por la Agencia, desde el primer
        documento o cotización, de los detalles del viaje. Comprende y acepta que los prestadores
        de servicios de transporte aéreo y terrestre pueden hacer modificaciones en horarios,
        postergaciones, cancelaciones, cambios de equipo o comodidades, por razones operativas o
        técnicas. En tales casos, la Agencia no asumirá responsabilidad más allá de la debida
        información y gestión, según lo previsto por las normas aplicables.
      </p>
      <p>
        El transporte aéreo de pasajeros se rige por la Ley de Aviación Civil, que reconoce el
        contrato de transporte como perfeccionado al emitirse el boleto de pasaje. Los servicios
        de transporte aéreo no regular (como el fletamento o charter) están contemplados por la
        ley como servicios distintos al transporte regular, sujetos a autorización administrativa
        y regulación específica. En los contratos de fletamento (charter), el operador (fletante)
        es responsable del cumplimiento de las obligaciones pactadas y de daños a pasajeros,
        carga o terceros, según lo estipulado en la Ley de Aviación Civil. En vuelos
        internacionales, aplica además la Convención de Montreal para cuestiones de
        responsabilidad, indemnización y límite de responsabilidad.
      </p>
      <p>
        <strong>1. Naturaleza del contrato y vigencia del boleto:</strong> Una vez emitido, el
        boleto de transporte aéreo constituye el contrato entre la aerolínea y el pasajero,
        independientemente de las fechas previstas de partida o regreso. El pasajero acepta
        contratar, simultáneamente con la reserva del viaje, un seguro que incluya cobertura para
        cancelación del transporte. Para hacer efectiva dicha cobertura, deberá presentar su
        reclamación directamente ante la aseguradora correspondiente, conforme a los términos de
        la póliza contratada.
      </p>
      <p>
        <strong>2. Aplicación de normas de transporte:</strong> En todo caso en que el transporte
        se efectúe por vía aérea, terrestre, marítima, lacustre o fluvial, el pasajero se somete
        expresamente a las normas particulares del contrato respectivo. Las indemnizaciones que
        correspondan se pagarán directamente al beneficiario o su representante legal, en la
        moneda, oportunidad y lugar determinados por el transportista, dentro de los límites
        fijados por la normativa aplicable.
      </p>
      <p>
        <strong>3. Horarios y contingencias del aeropuerto:</strong> Los aeropuertos están sujetos
        a condiciones operativas, climáticas o sanitarias. Los horarios de salida y llegada son
        aproximados; el pasajero debe presentarse con la anticipación requerida por la aerolínea
        o transportista. La Agencia queda exenta de responsabilidad por modificaciones, retrasos o
        cancelaciones originadas por decisiones de la aerolínea o autoridades aeroportuarias. No
        responderá por gastos adicionales generados por dichas situaciones.
      </p>
      <p>
        <strong>4. Equipaje:</strong> El equipaje permitido corresponderá a lo estipulado por la
        tarifa elegida. Si el viaje comprende distintos vuelos con diferentes compañías, el
        pasajero debe verificar los límites aplicables en cada segmento, ya que pueden variar. El
        equipaje es transportado bajo el riesgo del pasajero, salvo responsabilidad del
        transportista conforme a la normatividad vigente. La Agencia no será responsable por
        daños, pérdidas o deterioros del equipaje.
      </p>
      <p>
        <strong>5. Cancelación del boleto confirmado / desistimiento:</strong> Si la plaza de
        transporte aéreo ya fue confirmada y el pasajero cancela, no procederá reembolso del monto
        del boleto. Si el transportista no cumple con horarios o itinerarios por causas de fuerza
        mayor, clima u otras circunstancias técnicas, el pasajero no tendrá derecho a reembolso ni
        indemnización por el pasaje, salvo lo que establezca la normativa o convenios. Los
        servicios terrestres (hotel, excursiones, etc.) serán reembolsables según las condiciones
        de los prestadores involucrados y conforme a sus políticas.
      </p>
      <p>
        <strong>6. Presentación en aeropuerto:</strong> El pasajero debe presentarse en el aeropuerto
        con la anticipación adecuada: mínimo 2 horas antes para vuelos nacionales, 3 horas para
        vuelos internacionales, salvo que la aerolínea indique otro horario. Los horarios en el
        boleto corresponden a la hora local del punto de partida, escalas y destino. La Agencia
        podrá gestionar preferencia de asiento ante la aerolínea, pero no garantiza su asignación,
        ya que esto depende del transportista.
      </p>
      <p>
        <strong>7. Reprogramaciones, demoras y cancelaciones por aerolínea:</strong> Si la aerolínea
        modifica horarios, fechas o rutas, la Agencia informará al pasajero y propondrá alternativas,
        pero solo procederá con cambios con su conformidad previa. Las tarifas más económicas suelen
        tener restricción de cambios y reembolsos, y los cambios permitidos estarán sujetos a
        penalidades. El pasaje es nominativo, personal e intransferible. Cualquier error en el nombre
        podría impedir el embarque.
      </p>
      <p>
        <strong>8. Cesión y transferencia de reserva:</strong> El cliente podrá ceder o transferir su
        contrato turístico a otra persona, hasta 30 días antes de la fecha de salida, siempre que
        lo permitan los transportistas y proveedores involucrados. Si las edades de los
        beneficiarios cambian (mayores / menores), se ajustará el precio correspondiente. En todos
        los casos de cesión o transferencia, la Agencia cobrará una comisión del 10 % sobre el
        precio total del servicio.
      </p>
      <p>
        <strong>9. No show:</strong> Si el pasajero no se presenta en la fecha y hora convenidas,
        perderá todo derecho a reembolso o ajustes respecto de las reservas aéreas, terrestres u
        hoteleras, conforme a las políticas del proveedor.
      </p>
      <p>
        <strong>10. Derecho de revocación / desistimiento en contratos a distancia:</strong> Cuando el
        contrato se celebre a distancia (por internet, teléfono, etc.), el pasajero podrá ejercer
        el derecho de revocación en un plazo de 10 días naturales contados desde la celebración
        del contrato, siempre que la tarifa contratada permita reembolso bajo sus propias
        condiciones. Si la tarifa o contrato aéreo no permiten reembolso, el derecho de
        revocación no aplicará para esos importes ni para los costos no reembolsables.
      </p>
      <p>
        <strong>11. Limitaciones al derecho de permanencia:</strong> La Agencia o los operadores
        locales se reservan el derecho de expulsar del tour o servicio turístico a cualquier
        pasajero cuya conducta, salud, estado físico o comportamiento pueda poner en riesgo,
        causar molestia u obstruir el normal desarrollo del viaje, según criterio razonable de los
        prestadores locales. En dichos casos, se aplicarán las penalidades o condiciones
        establecidas en la cláusula de &quot;Alteraciones o Modificaciones&quot; del contrato.
      </p>

      <h4 className='text-lg text-black font-bold mt-6'>DOCUMENTACIÓN:</h4>
      <p>
        La Agencia informará por escrito y con anticipación suficiente sobre los requisitos
        migratorios, aduaneros, sanitarios y de seguridad exigidos por las autoridades mexicanas
        y extranjeras en relación con el destino del viaje contratado.
      </p>
      <p>Sin embargo, será responsabilidad exclusiva del pasajero:</p>
      <ul className='list-disc pl-6 space-y-1'>
        <li>Contar con pasaporte vigente, visas, permisos especiales, certificados de vacunación, constancias sanitarias, formularios migratorios u otra documentación que pudiera ser requerida por autoridades mexicanas o extranjeras, tanto para salir de México como para ingresar, transitar o permanecer en otros países.</li>
        <li>Obtener y presentar la documentación exigida en los plazos, formas y momentos requeridos por autoridades migratorias, sanitarias o policiales de los países involucrados en el itinerario.</li>
        <li>En su caso, tramitar a su cargo cualquier pasaporte sanitario o formulario de ingreso digital solicitado por el país de destino u origen.</li>
      </ul>
      <p><strong>Casos específicos:</strong></p>
      <p>
        a) <strong>Pasaportes y visas:</strong> El pasajero es responsable de verificar los requisitos de visa según su nacionalidad, para cada país de tránsito o destino, consultando fuentes oficiales, como la Secretaría de Relaciones Exteriores (SRE){' '}
        <a href='https://www.gob.mx/sre' target='_blank' rel='noreferrer' className={EXTERNAL_LINK_CLASS}>https://www.gob.mx/sre</a> o el sitio oficial de la embajada o consulado correspondiente.
      </p>
      <p>
        b) <strong>Vacunas y requisitos sanitarios:</strong> Corresponde al pasajero consultar y cumplir con los requisitos de vacunación o pruebas médicas que pudieran exigir los países involucrados, incluyendo posibles medidas sanitarias al reingreso a México. Puede consultarse la información oficial en: Secretaría de Salud:{' '}
        <a href='https://www.gob.mx/salud' target='_blank' rel='noreferrer' className={EXTERNAL_LINK_CLASS}>https://www.gob.mx/salud</a>
      </p>
      <p>
        c) <strong>Unidad de Sanidad Internacional:</strong>{' '}
        <a href='https://www.gob.mx/salud/acciones-y-programas/vacunacion-internacional' target='_blank' rel='noreferrer' className={EXTERNAL_LINK_CLASS}>https://www.gob.mx/salud/acciones-y-programas/vacunacion-internacional</a>
      </p>
      <p>
        d) <strong>Viajes con menores de edad:</strong> Cuando se viaja con personas menores de 18 años, se deberá presentar la documentación exigida por el Instituto Nacional de Migración (INM), como carta notariada de autorización del padre, madre o tutor en caso de que el menor viaje con uno solo o sin sus padres. Puede consultarse el procedimiento actualizado en:{' '}
        <a href='https://www.gob.mx/inm' target='_blank' rel='noreferrer' className={EXTERNAL_LINK_CLASS}>https://www.gob.mx/inm</a> (sección &quot;Viaje de menores al extranjero&quot;).
      </p>
      <p>
        e) <strong>Pasajeros extranjeros:</strong> Si el pasajero no es ciudadano mexicano, deberá informar a la Agencia dicha condición al momento de contratar, para que pueda recibir orientación específica sobre requisitos conforme a su nacionalidad. La Agencia no será responsable por errores, omisiones o incumplimientos en este sentido cuando el pasajero no haya informado su situación migratoria con precisión.
      </p>
      <p>
        f) <strong>Necesidades especiales o discapacidad:</strong> En caso de requerir asistencia especial en aeropuertos, vuelos, traslados o excursiones, el pasajero deberá notificar por escrito a la Agencia al momento de la contratación.
      </p>
      <p>
        g) Algunos destinos, atracciones o servicios turísticos podrían no estar adaptados a personas con movilidad reducida o presentar barreras físicas o logísticas que limiten su acceso. La Agencia informará al pasajero con anticipación sobre qué actividades o excursiones podrían verse limitadas o imposibilitadas, a fin de ajustar expectativas o considerar alternativas.
      </p>
      <p><strong>Limitaciones y exclusión de responsabilidad:</strong></p>
      <p>La Agencia no se hace responsable por:</p>
      <ul className='list-disc pl-6 space-y-1'>
        <li>La falta, vigencia vencida o errores en la documentación personal del pasajero.</li>
        <li>La denegación de ingreso o egreso por parte de cualquier autoridad migratoria o sanitaria.</li>
        <li>Multas, gastos o pérdidas derivadas de la imposibilidad de continuar el viaje por falta de documentos en regla.</li>
        <li>Rechazo de visado o imposibilidad de embarque por errores en el nombre, nacionalidad, validez del pasaporte o inconsistencias en los datos del pasajero.</li>
        <li>Requisitos extraordinarios o inesperados impuestos por cambios en las políticas migratorias, sanitarias o diplomáticas del país de destino o tránsito.</li>
      </ul>
      <p>
        En caso de que el pasajero no pudiera embarcar, ingresar o permanecer en un país por razones relacionadas con su documentación, visado o estado de salud, se aplicarán las penalidades establecidas en el apartado &quot;Cancelaciones, alteraciones o modificaciones del viaje&quot;.
      </p>

      <h4 className='text-lg text-black font-bold mt-6'>MENORES DE EDAD:</h4>
      <p>
        Para viajes internacionales desde México, los menores de 18 años de edad que viajen solos
        o acompañados por un solo padre, tutor o persona distinta a sus padres deberán cumplir con
        los requisitos establecidos por el Instituto Nacional de Migración (INM), conforme a la Ley
        de Migración, el Reglamento de Migración y demás normativas aplicables.
      </p>
      <p><strong>Requisitos migratorios para salida del país:</strong></p>
      <p>
        Conforme a la normativa vigente del INM, todo menor de edad que salga del territorio
        nacional sin la compañía de ambos padres, deberá presentar ante la autoridad migratoria en
        el aeropuerto o punto de salida:
      </p>
      <ul className='list-disc pl-6 space-y-1'>
        <li>Pasaporte vigente del menor</li>
        <li>Visa del país de destino, en caso de ser requerida</li>
        <li>Formato de Salida de Menores (SAM), debidamente llenado y autorizado</li>
        <li>Identificaciones oficiales de los padres o tutores</li>
        <li>Acta de nacimiento del menor, para acreditar el vínculo con los padres o tutores</li>
      </ul>
      <p><strong>Autorización de salida (cuando viaja con uno solo de los padres o sin ellos):</strong></p>
      <p>
        Cuando el menor viaja solo, o viaja acompañado solo por uno de los padres, o viaja con un
        tercero (no progenitor), deberá presentar el Formato SAM (Salida de Menores), que es el
        documento oficial requerido para autorizar la salida del país de menores mexicanos y debe ser:
      </p>
      <ul className='list-disc pl-6 space-y-1'>
        <li>Llenado en línea o manualmente</li>
        <li>Firmado por ambos padres o por quien ejerza la patria potestad o tutela</li>
        <li>Acompañado por copias de identificaciones oficiales y acta de nacimiento</li>
        <li>En algunos casos, certificado ante Notario Público o legalizado, especialmente si el padre o madre firmante no se encuentra en México</li>
      </ul>
      <p>
        El Formato SAM puede obtenerse en el sitio oficial del INM:{' '}
        <a href='https://www.gob.mx/inm' target='_blank' rel='noreferrer' className={EXTERNAL_LINK_CLASS}>https://www.gob.mx/inm</a> (Sección &quot;Salida de menores al extranjero&quot;)
      </p>
      <p><strong>En todos los casos, adicionalmente se requiere:</strong></p>
      <ul className='list-disc pl-6 space-y-1'>
        <li>Que el pasaporte del menor tenga al menos 6 meses de vigencia</li>
        <li>Que la documentación sea presentada en original y copia</li>
        <li>Que la fotografía del menor en el pasaporte esté actualizada</li>
        <li>Que el menor viaje con los documentos de identidad exigidos por el país de destino (visa, permiso sanitario, etc.)</li>
      </ul>
      <p>
        <strong>Para viajes internacionales a países angloparlantes:</strong> En caso de que se requiera
        traducción oficial del permiso de salida (Formato SAM), ésta deberá hacerse por perito
        traductor autorizado en México o conforme lo indique el consulado del país de destino. La
        firma del traductor debe estar legalizada o apostillada en los términos del país que lo exija.
      </p>
      <p><strong>Responsabilidad del pasajero:</strong></p>
      <p>Esta Agencia no será responsable por:</p>
      <ul className='list-disc pl-6 space-y-1'>
        <li>La obtención, tramitación o vigencia de los documentos personales del menor o sus acompañantes.</li>
        <li>Multas, sanciones, demoras o impedimentos para viajar por documentación incompleta, incorrecta o vencida.</li>
        <li>Costos derivados de la reprogramación, cancelación o abandono del viaje por falta de autorización migratoria.</li>
      </ul>
      <p><strong>Es obligación del pasajero:</strong></p>
      <ul className='list-disc pl-6 space-y-1'>
        <li>Informarse oportunamente sobre los requisitos migratorios y sanitarios para menores.</li>
        <li>Gestionar con anticipación la documentación necesaria en las instancias correspondientes (INM, SRE, Notarías, Consulados, etc.).</li>
        <li>Notificar a la Agencia si viaja con menores y si se requiere apoyo documental adicional.</li>
      </ul>
      <p><strong>Fuentes oficiales recomendadas:</strong></p>
      <ul className='list-disc pl-6 space-y-1'>
        <li>Instituto Nacional de Migración (INM): <a href='https://www.gob.mx/inm' target='_blank' rel='noreferrer' className={EXTERNAL_LINK_CLASS}>https://www.gob.mx/inm</a></li>
        <li>Secretaría de Relaciones Exteriores (SRE): <a href='https://www.gob.mx/sre' target='_blank' rel='noreferrer' className={EXTERNAL_LINK_CLASS}>https://www.gob.mx/sre</a></li>
        <li>Formato SAM en línea: <a href='https://www.inm.gob.mx/gobmx/word/index.php/formato-salida-menores/' target='_blank' rel='noreferrer' className={EXTERNAL_LINK_CLASS}>https://www.inm.gob.mx/gobmx/word/index.php/formato-salida-menores/</a></li>
        <li>Información general para viajeros con menores: <a href='https://www.gob.mx/inm/documentos/salida-de-menores-al-extranjero' target='_blank' rel='noreferrer' className={EXTERNAL_LINK_CLASS}>https://www.gob.mx/inm/documentos/salida-de-menores-al-extranjero</a></li>
      </ul>
      <p className='border border-gray-300 rounded bg-gray-100 p-3'>
        <strong>NOTA:</strong> a) La documentación también puede ser requerida en el territorio de países en tránsito, aun cuando no sea necesario salir del aeropuerto. b) Los requisitos varían según su nacionalidad, edad y lugar de residencia. c) Para viajar a cualquier país extranjero en calidad de turista es necesario poseer un billete y/o ticket de retorno y la estadía máxima no puede superar los 90 días (consultar excepciones en el consulado de destino. Asimismo, se advierte que podrían solicitarle fondos suficientes para su manutención, dirección del hospedaje y otros). Todo ello debe ser consultado con el consulado correspondiente.
      </p>

      <h4 className='text-lg text-black font-bold mt-6'>RESPONSABILIDAD: CARÁCTER DE INTERMEDIARIO:</h4>
      <p>
        <strong>1. Intermediación:</strong> Esta Agencia actúa exclusivamente en calidad de intermediaria
        entre el cliente (pasajero) y los prestadores directos de los servicios turísticos contratados,
        tales como: Transportistas aéreos, marítimos o terrestres; Establecimientos de hospedaje;
        Restaurantes; Operadores turísticos en destino; Compañías de asistencia al viajero; Y otros
        proveedores de servicios incluidos en el itinerario o paquete reservado. En consecuencia, esta
        Agencia no asume responsabilidad directa por la efectiva prestación de los servicios ofrecidos
        por terceros, ni por su calidad, cumplimiento, seguridad o continuidad, más allá de lo
        establecido por la Ley Federal de Protección al Consumidor.
      </p>
      <p>
        <strong>2. Casos fortuitos y fuerza mayor:</strong> La Agencia no será responsable por
        incumplimientos, demoras, modificaciones o cancelaciones parciales o totales de los servicios
        contratados que resulten de:
      </p>
      <ul className='list-disc pl-6 space-y-1'>
        <li>Fenómenos naturales (huracanes, sismos, tormentas, erupciones volcánicas, etc.)</li>
        <li>Condiciones climáticas extremas</li>
        <li>Emergencias sanitarias (epidemias, pandemias, brotes infecciosos)</li>
        <li>Conflictos bélicos, actos terroristas, disturbios sociales o políticos</li>
        <li>Cierres de fronteras, cambios migratorios, bloqueos o restricciones impuestas por gobiernos nacionales o extranjeros</li>
        <li>Casos fortuitos o de fuerza mayor conforme a lo dispuesto por el Código Civil Federal</li>
      </ul>
      <p>
        <strong>3. Información previa al viaje:</strong> La Agencia, actuando de buena fe, informará
        al pasajero sobre condiciones de riesgo, advertencias o restricciones sanitarias, migratorias
        o de seguridad que pudieran existir en el destino contratado, según la información disponible
        al momento de la reserva o antes de la salida. En caso de existir advertencias formales por
        parte de autoridades mexicanas (SRE, SEGOB, Secretaría de Salud) o de organismos
        internacionales, el pasajero deberá manifestar por escrito que ha sido informado y, aún así,
        decide continuar con el viaje bajo su propio riesgo.
      </p>
      <p>
        <strong>4. Disposiciones sanitarias y migratorias:</strong> Todo itinerario está sujeto a las
        disposiciones migratorias, sanitarias y de seguridad del país de origen, tránsito y destino al
        momento de iniciar, continuar o finalizar el viaje. La Agencia no será responsable por cambios
        de último momento en estas disposiciones ni por los efectos derivados de su incumplimiento por
        parte del pasajero.
      </p>
      <p>
        <strong>5. Prolongación de estadía por causas ajenas a la Agencia:</strong> En caso de que, por
        fenómenos climáticos, cancelaciones de vuelos, situaciones sanitarias o cualquier otro evento
        de fuerza mayor, el viaje se extienda más allá de lo contratado, los gastos adicionales en que
        incurra el pasajero por concepto de: Alojamiento; Alimentación; Transporte adicional; Gastos
        personales; Serán cubiertos por el pasajero exclusivamente, salvo que dichos gastos estén
        expresamente incluidos en algún servicio adicional previamente contratado o estén cubiertos por
        un seguro de asistencia al viajero, si el pasajero contrató alguno.
      </p>
      <p>
        <strong>6. Responsabilidad por daños a personas o equipaje:</strong> La Agencia no será
        responsable por lesiones, accidentes, pérdidas, daños o robo de equipaje u objetos personales,
        durante el trayecto o estadía, ya que estos riesgos son inherentes a los servicios prestados
        por terceros. La responsabilidad legal sobre dichos eventos corresponde a: Las líneas aéreas o
        transportistas, conforme a la Ley de Aviación Civil o la Ley de Caminos, Puentes y
        Autotransporte Federal; Los hoteles y proveedores de servicios turísticos directamente
        contratados. Se recomienda al pasajero contratar un seguro de viaje y asistencia que cubra
        estos eventos.
      </p>
      <p>
        <strong>7. Transporte terrestre:</strong> Cuando el transporte terrestre se realice en autobuses
        rentados o propios, el pasajero acepta someterse a las leyes y reglamentos de tránsito y
        transporte del país en que esté matriculado el vehículo. En caso de siniestro o percance, se
        aplicará la legislación vigente en la jurisdicción donde ocurra el hecho.
      </p>

      <h4 className='text-lg text-black font-bold mt-6'>ASISTENCIA AL VIAJERO:</h4>
      <p>
        Los pasajeros deberán contratar obligatoriamente un seguro o póliza de asistencia al viajero
        adecuada a: su edad / rango etario; destino (geolocalización); duración total del viaje;
        riesgos contemplados en el itinerario. Dicha póliza debe cubrir, como mínimo: atención
        médica y hospitalaria; traslado o repatriación sanitaria; pérdidas o daños a equipaje;
        cancelación o interrupción del viaje por causas justificadas; eventos derivados de
        emergencias sanitarias o pandemias (cuando la póliza lo permita explícitamente). El pasajero
        deberá verificar si en su destino existen exigencias específicas de cobertura médica o
        seguros para su ingreso. Si no contrata dicha asistencia, se entenderá que asume
        personalmente todos los riesgos de cualquier naturaleza que pudieran afectarlo a él, a sus
        bienes o a terceros, sin que la Agencia pueda ser responsable por esos eventos.
      </p>

      <h4 className='text-lg text-black font-bold mt-6'>DATOS PERSONALES:</h4>
      <p>
        Los datos personales que el pasajero proporcione para la reserva y contratación de servicios
        a través de esta Agencia serán tratados de acuerdo con la Ley Federal de Protección de Datos
        Personales en Posesión de los Particulares (y su versión vigente desde 21 de marzo de 2025).
        Los datos serán recabados únicamente para los fines relacionados con la gestión, operación y
        cumplimiento del contrato de servicios turísticos. Se conservarán únicamente durante el tiempo
        necesario para cumplir con esos fines, y posteriormente serán cancelados o bloqueados según las
        disposiciones aplicables. Solo se compartirán con terceros indispensables (hoteles, aerolíneas,
        operadores) para la efectiva ejecución de los servicios contratados, con las medidas de
        confidencialidad y seguridad correspondientes. El titular tiene derecho a ejercer los derechos
        de Acceso, Rectificación, Cancelación y Oposición (ARCO) respecto de sus datos personales,
        conforme a la ley. En comunicaciones con fines publicitarios (correo electrónico, mensaje,
        llamadas, internet u otros medios a distancia), se informará expresamente y de forma destacada
        la posibilidad de que el titular solicite el retiro o bloqueo de sus datos de las bases de
        datos de publicidad. A solicitud del interesado, se deberá informar el nombre del responsable
        que proporcionó sus datos, así como los bancos de datos en que están contenidos.
      </p>

      <h4 className='text-lg text-black font-bold mt-6'>ALTERACIONES / MODIFICACIONES:</h4>
      <p>
        La Agencia se reserva el derecho, por motivos técnicos u operativos, de modificar parcial o
        totalmente el orden de los servicios del viaje (itinerario, horarios, alojamientos u otros),
        siempre que los cambios no afecten sustancialmente la calidad del paquete. Los hoteles previstos
        podrían sustituirse por otros de igual o superior categoría, siempre en la misma zona o ciudad,
        sin costo adicional para el pasajero. Las modificaciones menores no generarán derecho a
        indemnización. El pasajero no podrá exigir compensación alguna por alteraciones razonables
        comunicadas previamente. Si una vez iniciado el viaje el pasajero decide suspender, modificar o
        interrumpir voluntariamente alguno de los servicios por razones personales, no tendrá derecho a
        reembolso ni indemnización por los servicios desistidos. En programas que incluyen transporte,
        alojamiento y excursiones, si no se alcanza el mínimo de participantes necesario para prestar el
        servicio, la Agencia podrá postergar, suspender o cancelar el trayecto. En esos casos, los
        pasajeros tendrán derecho al reembolso íntegro de lo que hayan pagado, sin intereses ni
        penalidad, salvo que en las condiciones particulares se estipule cosa distinta.
      </p>

      <h4 className='text-lg text-black font-bold mt-6'>COMUNICACIÓN ENTRE LAS PARTES:</h4>
      <p>
        Las partes acuerdan, en pleno uso de su autonomía de la voluntad y conforme a lo dispuesto
        por los artículos 80 y 89 del Código de Comercio, así como la Ley de Firma Electrónica
        Avanzada, que toda comunicación, contratación, aceptación de términos y documentación
        vinculada a los servicios turísticos podrá realizarse de forma presencial o a través de
        medios electrónicos, incluyendo correo electrónico, mensajería instantánea, formularios en
        línea o cualquier otro medio digital que permita dejar constancia de su contenido.
      </p>
      <p>
        Asimismo, el contrato de prestación de servicios turísticos podrá celebrarse mediante medios
        electrónicos, siempre que se garantice: la identidad del pasajero; el consentimiento expreso, y
        la conservación y disponibilidad de la información conforme a las disposiciones aplicables.
      </p>
      <p>
        La contratación de los servicios se encuentra sujeta a la autorización sanitaria, migratoria y
        regulatoria vigente en México y en los países de tránsito o destino, en la fecha de inicio y/o
        conclusión del viaje. Además, aerolíneas, navieras y demás prestadores de servicios turísticos
        vinculados podrán establecer protocolos sanitarios, operativos o de seguridad, los cuales
        deberán ser acatados estrictamente por los pasajeros. La Agencia se compromete a proporcionar
        al pasajero la información actualizada sobre dichas medidas con la debida anticipación. Es
        responsabilidad del pasajero mantenerse informado sobre las disposiciones vigentes en materia
        sanitaria, migratoria y de seguridad internacional, tanto en México como en los países a los
        que planea viajar.
      </p>

      <h4 className='text-lg text-black font-bold mt-6'>INCUMPLIMIENTO:</h4>
      <p>
        En caso de que exista una diferencia real y comprobable entre los servicios ofertados y los
        efectivamente contratados o prestados, el pasajero podrá ejercer sus derechos conforme a la Ley
        Federal de Protección al Consumidor (LFPC), acudiendo a las instancias de protección
        correspondientes, tales como: Procuraduría Federal del Consumidor (PROFECO), el Servicio de
        Conciliación en Línea (Concilianet), o los mecanismos alternativos de solución de controversias
        reconocidos por la propia PROFECO, como el arbitraje de consumo. Para ello, el pasajero podrá
        presentar una reclamación ante la oficina de PROFECO correspondiente a su domicilio o bien
        hacerlo a través del portal oficial:{' '}
        <a href='https://www.gob.mx/profeco' target='_blank' rel='noreferrer' className={EXTERNAL_LINK_CLASS}>
          https://www.gob.mx/profeco
        </a>
      </p>
      <p>
        El pasajero también podrá iniciar el procedimiento previsto en la LFPC para solicitar el
        cumplimiento forzoso de la prestación, el reemplazo del servicio, la devolución de cantidades
        pagadas o la indemnización por daños y perjuicios, según corresponda.
      </p>
    </div>
  );
}
